// ChristmasEvent.js (Đã cập nhật)

import React, { useState, useEffect } from 'react';
import Navbar from './Navbar'; // Đảm bảo đường dẫn đúng
import './ChristmasEvent.css'; // File CSS riêng cho trang này
import luckyTicketImage from './assets/lucky_ticket.jpg'; //
import { useNavigate } from 'react-router-dom'; // IMPORT MỚI

const ChristmasEvent = () => {
  const navigate = useNavigate(); // KHỞI TẠO HOOK MỚI

  const calculateTimeLeft = () => {
    // ... (Code tính giờ đếm ngược giữ nguyên)
    const eventDate = new Date('2025-12-20T19:00:00');
    const now = new Date();
    const difference = eventDate - now;

    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const luckyDrawActivity = {
    title: "🔥 Bốc Thăm May Mắn - Giải Thưởng Khủng! 🔥",
    icon: "🎁",
    desc: "Cơ hội rinh ngay các giải thưởng giá trị lớn: **XE MÁY ĐIỆN**, **MÁY GIẶT**, **QUẠT HƠI NƯỚC**, **NỒI CHIÊN KHÔNG DẦU**, Bàn Ủi, và nhiều quà tặng bất ngờ khác! Mua phiếu để thử vận may của bạn!"
  };

  // HOẠT ĐỘNG LÔ TÔ ĐƯỢC TÁCH RIÊNG RA KHỎI MẢNG activities
  const lotoActivity = {
    title: "🔢 Lô Tô Vui Nhộn - Dò Giải Tức Thì! 🔢",
    icon: "🎰",
    desc: "Mỗi phiếu may mắn sẽ đính kèm một phiếu lô tô ở mặt sau. Đừng lo lắng về việc mua quá nhiều vé, hãy để ứng dụng **Dò Lô Tô Thông Minh** của chúng tôi giúp bạn theo dõi kết quả. Cơ hội trúng nhiều phần quà bất ngờ khi tham gia hội chợ giáng sinh!"
  };

  // Mảng activities đã loại bỏ "Lô Tô Vui Nhộn"
  const activities = [
    {
      title: "Hội Chợ Trò Chơi",
      icon: "🎯",
      desc: "Nhiều gian hàng trò chơi dân gian và hiện đại dành cho thiếu nhi."
    },
    {
      title: "Hội Chợ Ẩm Thực",
      icon: "🌭",
      desc: "Thưởng thức các món ăn ngon, vệ sinh với giá cả 'hạt dẻ'."
    },
    {
      title: "Sân Khấu Ca Nhạc",
      icon: "🎤",
      desc: "Các tiết mục văn nghệ đặc sắc mừng Chúa Giáng Sinh đến từ các em thiếu nhi."
    }
  ];

  // HÀM XỬ LÝ CHUYỂN TRANG
  const handleNavigateToLoto = () => {
    // Giả định trang dò lô tô sẽ có route là '/loto-scanner'
    navigate('/loto-scanner');
  };

  return (
    <div className="christmas-page-container">
      <Navbar />
      <div className="christmas-hero">
        <h1>HỘI CHỢ GIÁNG SINH 2025</h1>
        <p className="event-subtitle">Giáo Xứ An Nhơn</p>
        <div className="countdown-container">
          <h2 className="result-announcement-title">🎊 ĐÃ CÓ KẾT QUẢ BỐC THĂM 🎊</h2>
        </div>
      </div>

      {/* SECTION CÔNG BỐ KẾT QUẢ MAY MẮN */}
      <div className="lucky-draw-main-section result-mode">
        <div className="lucky-draw-content">
          <div className="lucky-draw-icon">🎁</div>
          <h2>KẾT QUẢ PHIẾU MAY MẮN</h2>

          <div className="event-results-board">
            <div className="result-card grand">
              <div className="prize-label">🏆 GIẢI ĐẶC BIỆT</div>
              <div className="winning-number">250370</div>
            </div>

            <div className="minor-results-grid">
              <div className="result-card secondary">
                <div className="prize-label">🥇 Giải Nhất</div>
                <div className="winning-number">255522</div>
              </div>
              <div className="result-card secondary">
                <div className="prize-label">🥈 Giải Nhì</div>
                <div className="winning-number">250251</div>
              </div>
              <div className="result-card secondary">
                <div className="prize-label">🥉 Giải Ba</div>
                <div className="winning-number">250721</div>
              </div>
              <div className="result-card secondary">
                <div className="prize-label">🧧 Giải Khuyến Khích</div>
                <div className="winning-number">250099</div>
              </div>
            </div>
          </div>

          <p className="note-red">* Quý khách vui lòng mang theo phiếu đối chiếu gốc đến Văn phòng Giáo xứ để nhận thưởng.</p>
        </div>
      </div>

      {/* SECTION MỚI: LÔ TÔ VUI NHỘN (Dùng class mới để đổi màu sắc) */}
      <div className="loto-main-section">
        <div className="loto-content">
          <div className="loto-icon">{lotoActivity.icon}</div>
          <h2>{lotoActivity.title}</h2>
          <p>{lotoActivity.desc}</p>

          <button
            className="loto-button"
            onClick={handleNavigateToLoto}
          >
            Dò Lô Tô Thông Minh
          </button>

          <p className="note">Nhấn vào nút trên để quản lý và dò các vé lô tô của bạn một cách nhanh chóng và chính xác!</p>
        </div>
      </div>

      {/* CÁC HOẠT ĐỘNG KHÁC (Đã đổi tên class để phân biệt) */}
      <h2 className="section-title-other">Các Hoạt Động Khác</h2>
      <div className="other-activities-list">
        {activities.map((item, index) => (
          <div key={index} className="activity-card">
            <div className="activity-icon">{item.icon}</div>
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChristmasEvent;